export default __webpack_public_path__ + "static/media/service.d0c8c0f3.jpg";